import './_collection-header.scss';

export default () => {};
